const params = new URLSearchParams(window.location.search)
export const initialProvider = params.get('provider')
